var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilitaryTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fe9900;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48,
    height: 48,
    transform: "translate(89 230)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-89 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 230)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34,20.86V6a2.006,2.006,0,0,0-2-2H16a2.006,2.006,0,0,0-2,2V20.86a1.98,1.98,0,0,0,.98,1.72l8.36,5.02-1.98,4.68-4.44.38a1,1,0,0,0-.6,1.76l3.38,2.92L18.68,41.7a1,1,0,0,0,1.5,1.08L24,40.46l3.82,2.3a1,1,0,0,0,1.5-1.08L28.3,37.32l3.38-2.92a1.006,1.006,0,0,0-.58-1.76l-4.44-.38-1.98-4.68,8.36-5.02A1.924,1.924,0,0,0,34,20.86Zm-8,3.6-2,1.2-2-1.2V6h4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitaryTech);
export default __webpack_public_path__ + "static/media/military_tech.336b47a302fbb83a367165d104a9106b.svg";
export { ForwardRef as ReactComponent };